/* global WEBPACK_INLET_VERSION */
/* global WEBPACK_INLET_CONFIG */

var inlet = require('aem-libs/src/initInlet.js').initInlet('AemUniforms', WEBPACK_INLET_VERSION)
var angular = require('angular')
require('aem-libs-uniforms/src/themes/csas/style.css')
require('aem-libs-uniforms-angularjs/src/components/uniform-detail/uniform-detail.component.js')

angular.module('AemUniforms', ['UniformDetailCmp'])

require('./inlet.css')
require('./inlet.controller.js')

require('aem-libs-angularjs/src/bootstrap').bootstrap({
  element: inlet.element,
  appName: 'AemUniforms',
  mainCtrlName: 'aemUniformsCtrl',
  basePath: inlet.basePath,
  config: WEBPACK_INLET_CONFIG,
  supportedLanguages: {
    cs: require('./i18n/cs.js').cs,
    en: require('./i18n/en.js').en
  },
  html: require('./inlet.html')
})
